import { Text } from "@mantine/core";
import { type FragmentOf, graphql, readFragment } from "gql.tada";

import { EffectRow } from "./EffectRow";

export const RuleEngineEffectEmitSeedingPinFragment = graphql(`
  fragment RuleEngineEffectEmitSeedingPinFields on RuleEngineEffectEmitSeedingPinPayload {
    __typename
    effectKind
    stepId
    groupId
    gameId
    slotIndex
    targetTeamId
    applied
    skipReason
  }
`);

interface Props {
  data: FragmentOf<typeof RuleEngineEffectEmitSeedingPinFragment>;
}

export function RuleEngineEffectEmitSeedingPinPayload({ data }: Props) {
  const p = readFragment(RuleEngineEffectEmitSeedingPinFragment, data);
  return (
    <EffectRow
      applied={p.applied}
      appliedColor="indigo"
      appliedLabel="EMIT_SEEDING_PIN"
      skipReason={p.skipReason}
    >
      team {p.targetTeamId.slice(0, 8)} → game {p.gameId.slice(0, 8)} slot{" "}
      {p.slotIndex}
      {" · "}
      <Text span size="xs" c="dimmed">
        step {p.stepId.slice(0, 8)} · group {p.groupId.slice(0, 8)}
      </Text>
    </EffectRow>
  );
}
